export default "__VITE_ASSET__BHGye7Ol__"